import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector, RootStateOrAny } from 'react-redux';
import { useHistory } from 'react-router-dom';

import {
  PaginateCarrierAreaContactsActions,
  PaginateCarrierAreaContactsState,
} from 'store/ducks/settings/carrier-area-contact';

import { SelectedFilterActions, SelectedFilterState } from 'store/ducks/filter';

import * as S from './styles';
import { useTranslation, usePermissions } from 'hooks';
import { translations } from './translations';
import { MainContainer, Paginator, MenuSelector } from 'components/shared';
import { FilterCarrierAreaContacts } from 'components/settings';
import { GridCarrierAreaContacts } from 'components/settings/Carriers/GridCarrierAreaContacts';

export const ListCarrierContacts: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { getTranslation } = useTranslation(translations);
  const { checkUserPermission } = usePermissions();

  const [query, setQuery] = useState({
    limit: 10,
    page: 1,
  });
  const { data, loading, pagination } = useSelector<RootStateOrAny>(
    (state) => state.paginateCarrierAreaContacts
  ) as PaginateCarrierAreaContactsState;

  const { data: dataFilter } = useSelector<RootStateOrAny>(
    (state) => state.selectedFilter
  ) as SelectedFilterState;

  const handleSubmitFilter = useCallback(
    (value) => {
      const data = {
        ...dataFilter,
        ...value,
        page: 1,
      };
      dispatch(SelectedFilterActions.success(data));
      setQuery((state) => ({ ...state, data }));
    },
    [setQuery, dispatch, dataFilter]
  );

  const handlePageChange = useCallback(
    (value) => {
      const data = {
        ...dataFilter,
        page: value,
      };
      dispatch(SelectedFilterActions.success(data));
      setQuery((state) => ({ ...state, data }));
    },
    [setQuery, dispatch, dataFilter]
  );

  const getData = useCallback(() => {
    dispatch(
      PaginateCarrierAreaContactsActions.request({ ...query, ...dataFilter })
    );
  }, [dispatch, query, dataFilter]);

  useEffect(() => {
    getData();
  }, [getData]);
  return (
    <MainContainer>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          {getTranslation('configuracoes')}{' '}
          <MenuSelector page="carriers-contacts" />
          {loading && <S.LoadingPage />}
        </h1>
        <S.HeaderButtons>
          {checkUserPermission('insertCarriers') && (
            <S.ButtonMini
              onClick={() => history.push('/settings/carrier-contact/new')}
            >
              {getTranslation('novoContato')}
            </S.ButtonMini>
          )}
          <FilterCarrierAreaContacts onFilter={handleSubmitFilter} />
        </S.HeaderButtons>
      </S.PageHeader>
      <S.PageContent>
        <GridCarrierAreaContacts contacts={data} />
        <Paginator
          pagination={pagination}
          onPageChange={handlePageChange}
          loading={loading}
        />
      </S.PageContent>
    </MainContainer>
  );
};
